import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Contact } from '../../../../shared/model';
import { SystemSelectService } from '../../system-select/system-select.service';
import { FunctionContactService, ProjectFunctionContactService } from '../../camtl.service';

@Component({
  selector: 'app-camtl-project-contacts',
  templateUrl: './camtl-project-contacts.component.html',
  // styleUrls: ['./camtl-project-contacts.component.scss']
})
export class CamtlProjectContactsComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private functionContactService: FunctionContactService,
    private projectFunctionContactService: ProjectFunctionContactService,
  ) { }

  gridFilter: boolean;
  editForm: FormGroup;
  private isNew: boolean = false;
  editDataItem: Contact;;
  system: any;
  private systemId: any;

  ngOnInit() {
    var self = this;

    this.systemSelectService.system$
      .subscribe(system => {
        this.system = system;

        if (this.system) {
          this.systemId = this.system.Id;
        }
        else {
          this.systemId = undefined;
        }
        this.refresh();
      });

    this.systemSelectService.get();

    this.editForm = this.formBuilder.group({
      SystemId: [""],
      ContactId: [""],
      FunctionId: [""]
    })
  }

  refresh() {
    this.gridFilter = !this.gridFilter;
  }

  onRead = () => {
    var self = this;
    if (this.systemId) {
      return this.projectFunctionContactService.read("/" + this.systemId, true).then(function (dataItem) {
        for (var i = 0; i < dataItem.length; i++) {
          if (dataItem[i].Required) {
            dataItem[i].Description = dataItem[i].Description;
          }
        }
        return dataItem;
      });
    }
    return Promise.resolve([]);
  }

  columns: any[] =
    [
      {
        field: "Description",
        title: "Function",
        checkRequired: true
      },
      {
        field: "ContactName",
        title: "Name"
      }
    ]

  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true
    },
    columns: this.columns,
    service: this.projectFunctionContactService,
    fileName: "projectContacts.xlsx",
    read: this.onRead
  };

  formDialog = {
    title: "Contact",
    formControls: [
      {
        type: 'combobox',
        name: 'ContactId',
        title: 'Name',
        textField: 'ContactName',
        valueField: 'ContactId',
        placeholder: 'Select Contact...',
        service: this.functionContactService,
        sync: true
      }
    ]
  }
}
